import React from 'react';
import FrameL, { Img } from 'component/FrameL';
import ReactMarkdown from 'react-markdown';

import './style.css';

export default ({ cmsData, className = '', alignItemsClass = 'items-center', reverse = false, headingClasses = '', imageAreaSize }) => {
    let { media = {}, heading, subheading, description, links = [] } = cmsData;
    let gridStyle = {};
    if (imageAreaSize !== undefined) {
        gridStyle.gridTemplateAreas = reverse ?
            `'${'b '.repeat(10 - imageAreaSize) + 'a '.repeat(imageAreaSize)}'` :
            `'${'a '.repeat(imageAreaSize) + 'b '.repeat(10 - imageAreaSize)}'`;

    }

    return <section className='break-out-banner'>
        <div
            style={gridStyle}
            className={`introduction-banner__grid xl:container mx-auto ${className} ${alignItemsClass} ${reverse ? 'reverse' : ''}`}>
            <Img className='w-full' Image={media} />
            <div class="stack-l justify-center">
                <div className={headingClasses}>
                    {subheading && <h4 className="h6">{subheading}</h4>}
                    {heading && <h3 className="h3">{heading}</h3>}
                </div>
                <ReactMarkdown className='markdown-list'>{description}</ReactMarkdown>
                {links.length !== 0 && <div className="cluster-l">
                    {links.map(({ displayText, url }, i) => <a key={i} className='btn btn-primary uppercase' href={url}>{displayText}</a>)}
                </div>}
            </div>
        </div>
    </section>;
};
